class CityModel {
    constructor(data) {
        this.id = data?.id;
        this.name = data?.name;
    }
}

export default CityModel;
